<main class="account-verified">
  <section class="account-verified__card" aria-labelledby="verified-title">
    <div class="account-verified__icon" aria-hidden="true">
      <i class="fa fa-check"></i>
    </div>

    <h1 id="verified-title">Account Verified Successfully</h1>
    <p>
      <strong>{{ userName }}'s</strong> account has been activated and is ready
      to use.
    </p>

    <a class="account-verified__button" routerLink="/login">
      Login to Your Account
    </a>
  </section>
</main>
